import Link from "next/link";
import { useContext } from "react";
import { useSelector } from "react-redux";

import useFetchKitItems from "@hooks/kit/use-fetch-kit-items";

import { getCartItemsCount } from "@store/selectors/cart";
import { getIsBundleShop } from "@selectors/store";

import { getCartRoute } from "@constants/routes";

import { StoreContext } from "@components/store/provider";

import styles from "./main.module.scss";

const RESTRICTED_SOURCES_FOR_BAG_AND_ITEM = ["cart", "checkout"];

const CartIcon = () => {
  const { source, storeBasePath, isNewSwagmagicHost } = useContext(StoreContext);

  const isKitShop = useSelector(getIsBundleShop);
  const itemsCount = useSelector(getCartItemsCount);

  const { totalProductCount } = useFetchKitItems({ fetchKit: isKitShop });

  const restricted = RESTRICTED_SOURCES_FOR_BAG_AND_ITEM.includes(source);
  if (restricted) return null;

  const itemsInBag = isKitShop ? totalProductCount : itemsCount;

  const itemsPresentInBag = itemsInBag > 0;
  return (
    <div className={styles.cartContainer}>
      <Link
        href={getCartRoute({ storeBasePath })}
        className={isNewSwagmagicHost ? styles.cartIconButton : styles.storePointLink}
        title="cart"
        prefetch={false}
      >
        <span className={styles.cartIconContainer}>
          <i
            className={
              isNewSwagmagicHost
                ? styles.cartIcon
                : `${styles.iconShopping} ${styles.iconShoppingFill}`
            }
          />
          {itemsPresentInBag && <span className={styles.bagCount}>{itemsInBag}</span>}
        </span>
      </Link>
    </div>
  );
};

export default CartIcon;
